import {
  PortfolioRepo as portfolioRepo,
  PortfolioRepo,
} from "@services/portfolio.repo";
import { PortfolioUtilities as portfolioUtilities } from "@common/portfolio.utilities";
import { ClientRepo } from "@services/clients/client.repo";
import * as _ from "lodash";
import { portfolioSelectorService } from "@app/portfolio/portfolioSelector";
import * as echarts from "echarts";
import * as moment from "moment";
import {
  AssetClassNames,
  AssetClassColourArray,
  AssetClassNameArray,
  AssetClassColour,
} from "@common/enums/AssetClassType";
import { GraphColourArray } from "@common/enums/GraphColours";
import { Localities } from "@common/enums/Locality";
import { CurrencyList } from "@common/enums/Currency";
import {
  ExternalSourceName,
  ExternalSourcesList,
} from "@common/enums/ExternalSources";
import { AuthService } from "@common/auth.service";
import { extractErrorMessage } from "@common/utils/errorUtils";

class PortfolioManagerSummaryController implements angular.IOnInit {
  public isLoading: boolean = false;

  public isLoadingAssetClassBreakDowns = false;

  public isLoadingSecurityBalances = false;

  public isLoadingExcel = false;

  public latestPVDate;
  public latestMCBPVDate;
  public latestEDRPVDate;
  public latestMCBEOMDate;

  public MCBExternalSourceName = ExternalSourceName.MCB;
  public EDRExternalSourceName = ExternalSourceName.EDR;

  public userClientsPortfolios: Array<any>;
  public clients: Array<any>;
  public portfolios: Array<any> = [];

  public selectedClients: Array<any>;
  public selectedPortfolios: Array<number> = [];

  public isSelectAll: boolean = true;
  public selectAllOptionValue = -1;

  //currency list
  public currencyList = CurrencyList;
  public selectedCurrency;

  public assetClass: any;
  public localAssetClassBreakdown: Array<any> = [];
  public internationalAssetClassBreakdown: Array<any> = [];

  public totalCash: number;
  public totalLocalCash: number;
  public totalInternationalCash: number;
  public totalNAV: number;
  public totalLocalNAV: number;
  public totalInternationalNAV: number;

  public performances;
  public localYTDPerformance;
  public internationalYTDPerformance;
  public combinedYTDPerformance;

  public showManagerSummary: boolean = true;

  // Locality List
  public localityList = Localities;
  public selectedLocality;

  //External Source List
  public externalSourcesList = ExternalSourcesList;
  public selectedExternalSource;
  public genericFileList

  //client summary
  public clientSummaryItems: Array<any>;

  //Asset Class Totals
  public assetClassTotals: Array<any>;
  public assetClassesTotal: number;
  private assetClassPieChart: any;
  private assetClassPieChartOptions: any;
  public selectedAssetClassName: string;
  public totalMarketValue: number;

  //Display All Clients
  public displayAllClients: boolean = false;

  // Security and Cash Balances
  public securityBalances: Array<any>;
  public securityBalancesBreakdown: Array<any>;

  // sector chart
  public sectorPieChart;
  public sectorPieChartOptions;

  // geography chart
  public geographyPieChart;
  public geographyPieChartOptions;

  // currency chart
  public currencyPieChart;
  public currencyPieChartOptions;

  private minScreenWidth: number = 400;

  public displayExcelDate = false;
  public selectedExcelDate = new Date();
  public currentDate = new Date();

  public genericReconciledDates = false;

  /** @ngInject */
  constructor(
    private portfolioRepo: portfolioRepo,
    private portfolioUtilities: portfolioUtilities,
    private portfolioSelectorService: portfolioSelectorService,
    private $state: angular.ui.IStateService,
    private notifyjs,
    private clientRepo: ClientRepo,
    private $scope: angular.IScope,
    private $window: angular.IWindowService,
    private authService: AuthService
  ) {
    this.assetClassPieChart = echarts.init(
      document.getElementById("asset-class-pie-chart")
    );
    this.assetClassPieChart.on("click", this.onAssetChartClick.bind(this));

    this.sectorPieChart = echarts.init(
      document.getElementById("total-sector-pie-chart")
    );
    this.geographyPieChart = echarts.init(
      document.getElementById("total-geography-pie-chart")
    );
    this.currencyPieChart = echarts.init(
      document.getElementById("total-currency-pie-chart")
    );

    this.$scope.$watch(
      () =>
        this.sectorPieChart.getDom().parentElement.parentElement.clientWidth,
      this.sectorPieChart.resize()
    );
    this.$scope.$watch(
      () =>
        this.geographyPieChart.getDom().parentElement.parentElement
          .clientHeight,
      this.geographyPieChart.resize()
    );
    this.$scope.$watch(
      () =>
        this.currencyPieChart.getDom().parentElement.parentElement.clientHeight,
      this.currencyPieChart.resize()
    );
  }

  $onInit() {
    // Redirect ClientDetailsViewOnly users to clients page
    if (this.authService.isClientDetailsViewOnly()) {
      this.$state.go("root.portfolioManagement.clients");
      return;
    }

    this.selectedCurrency = "MUR";
    this.selectedLocality = _.first(
      Localities.filter((locality) => locality.name === "Combined")
    ).id;
    this.selectedExternalSource = "";
    

    this.getUserPortfoios();

    this.getLatestPVDate();

    this.getPortfolioManagerClientSummary();

    this.getAssetClassBalancesByExternalSource();

    //this.getSecurityBreakdownForGraphs();

    this.$scope["clientSummaryGridOptions"] = {
      data: [],
      urlSync: false,
    };
  }

  getUserPortfoios() {
    this.isLoading = true;
    this.portfolioRepo
      .getUserPortfolios()
      .then((res) => {
        this.userClientsPortfolios = res.data as Array<any>;
        this.userClientsPortfolios = _.orderBy(
          this.userClientsPortfolios,
          "clientName"
        );
        this.clients = _.map(this.userClientsPortfolios, (client) => {
          return {
            name: client.clientName,
            id: client.clientId,
            clientNumber: client.clientNumber,
            isSelected: true,
            portfolios: client.portfolios,
          };
        });

        this.portfolios = _.flatten(
          _.map(this.clients, (client) => {
            return _.flatten(
              _.map(client.portfolios, (portfolio: any) => {
                if (portfolio.sources != null || portfolio.sources != "") {
                  return {
                    id: portfolio.id,
                    name: portfolio.name,
                    clientId: client.clientId,
                  };
                }
              })
            );
          })
        );

        this.selectedPortfolios = _.map(this.portfolios, (portfolio: any) => {
          return portfolio.id;
        });
      })
      .catch((err) => {
        this.notifyjs("Failed to get user portfolios " + extractErrorMessage(err));
      })
      .finally(() => {
        this.getAssetClassesBreakdown();
        this.getPerformanceForSelectedPortfolios();

        // hack to add the select all as the option
        //this.selectedPortfolios.push(-1);

        this.isLoading = false;
      });
  }

  onSelectClose() {
    if (this.selectedPortfolios.length > 0) {
      let selectedPortfolios = _.filter(
        this.selectedPortfolios,
        (portfolioId) => {
          return portfolioId != -1;
        }
      );
      if (selectedPortfolios.length > 0) {
        this.updateData();
      }
    }
  }

  public getSelectedText() {
    if (
      this.selectedPortfolios.length - 1 ==
      this.getPotentialPortfolios().length
    )
      return "All My Portfolios";

    return `${this.selectedPortfolios.length} of ${
      this.getPotentialPortfolios().length
    } Portfolios`;
  }

  goToClientPortfolio($event: angular.IAngularEvent, clientNumber: number) {
    $event.stopPropagation();

    this.$state.go("root.portfolioManagement.clients.portfolio", {
      clientNumber,
    });
  }

  getPotentialPortfolios() {
    return this.portfolios;
  }

  getLatestPVDate() {
    this.clientRepo
      .getLatestPVDates()
      .then((res) => {
        let dataFeedData: any = res.data;

        this.latestMCBPVDate = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
                  !dataFeed.isReconciled
                );
              })
            ).fileDate
          )
        ).format("DD-MM-YYYY");

        this.latestEDRPVDate = moment(
          new Date(
            _.first(
              _.filter(dataFeedData, (dataFeed) => {
                return (
                  dataFeed.dataFeedSourceName === this.EDRExternalSourceName
                );
              })
            ).fileDate
          )
        ).format("DD-MM-YYYY");

        this.latestMCBEOMDate = _.first(
          _.filter(dataFeedData, (dataFeed) => {
            return (
              dataFeed.dataFeedSourceName === this.MCBExternalSourceName &&
              dataFeed.isReconciled
            );
          })
        );

        let fileDates = dataFeedData
          .filter((feed) => {
            return !feed.isReconciled;
          })
          .map((feed) => {
            return moment(new Date(feed.fileDate));
          });

        this.latestPVDate = moment.min(fileDates).format("DD-MM-YYYY");
      })
      .then(() => {
        this.getLatestGenericDates();
      });
  }
  
  convertDataReconciled(date) {
      return moment(new Date(date)).format("DD-MM-YYYY");
    }

  getLatestGenericDates() {
    this.clientRepo.getLatestGenericPVDates(this.latestPVDate).then((res) => {
      let dataFeedData: any = res.data;
      this.genericFileList = dataFeedData;
      let fileDates = dataFeedData
        .filter((feed) => {
          return !feed.isReconciled;
        })
        .map((feed) => {
          return moment(new Date(feed.fileDate));
        });

      var newlatestPVDate = moment.min(fileDates).format("DD-MM-YYYY");
      var oldLatestPVDate = this.latestPVDate;
      this.latestPVDate = moment
        .max([moment(newlatestPVDate, "DD-MM-YYYY"), moment(oldLatestPVDate, "DD-MM-YYYY")])
        .format("DD-MM-YYYY");
      let filterDates = dataFeedData.filter((feed) => {
        return (
          moment(new Date(feed.fileDate)) !==
          moment(new Date(this.latestPVDate))
        );
      });
      if (filterDates.length > 0) {
        this.genericReconciledDates = true;
      }
    });
  }

  formatDate = (date) => {
    return moment(new Date(date)).format("DD-MM-YYYY");
  };

  selectAllPortfolios() {
    this.isSelectAll = !this.isSelectAll;
    if (this.isSelectAll) {
      this.selectedPortfolios = [];
      this.selectedPortfolios = _.map(this.portfolios, (portfolio: any) => {
        return portfolio.id;
      });
    } else {
      this.selectedPortfolios = [];
      this.selectedPortfolios.push(-1);
    }
  }

  onSelectCurrencyClose() {
    this.updateData();
    this.getPortfolioManagerClientSummary();
    this.getAssetClassBalancesByExternalSource();
    this.loadTotalAssetClassSecurities();
  }

  getAssetClassesBreakdown() {
    this.isLoading = true;
    console.log(this.selectedPortfolios)
    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.selectedCurrency,
        null,
        this.selectedPortfolios
      )
      .then((res) => {
        this.isLoading = true;
        this.assetClass = res as Array<any>;

        this.totalCash = _.reduce(
          _.filter(
            this.assetClass,
            (assetClass) => assetClass.name == AssetClassNames.CASH
          ),
          (sum, n) => {
            return sum + n.total;
          },
          0
        );
        this.totalNAV = _.reduce(
          this.assetClass,
          (sum, n) => {
            return sum + n.total;
          },
          0
        );

        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
      });

    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.selectedCurrency,
        "LOCAL",
        this.selectedPortfolios
      )
      .then((res) => {
        this.isLoading = true;
        this.localAssetClassBreakdown = res as Array<any>;

        this.totalLocalNAV = _.reduce(
          this.localAssetClassBreakdown,
          (sum, assetClass) => {
            return sum + assetClass.total;
          },
          0
        );

        this.totalLocalCash = _.first(
          this.localAssetClassBreakdown.filter(
            (assetClass) => assetClass.name === AssetClassNames.CASH
          )
        ).total;
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
      });

    this.portfolioRepo
      .getPortfolioAggregatesByAssetClasses(
        null,
        this.selectedCurrency,
        "INTERNATIONAL",
        this.selectedPortfolios
      )
      .then((res) => {
        this.isLoading = true;
        this.internationalAssetClassBreakdown = res as Array<any>;

        this.totalInternationalNAV = _.reduce(
          this.internationalAssetClassBreakdown,
          (sum, assetClass) => {
            return sum + assetClass.total;
          },
          0
        );

        this.totalInternationalCash = _.first(
          this.internationalAssetClassBreakdown.filter(
            (assetClass) => assetClass.name === AssetClassNames.CASH
          )
        ).total;
        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
      });
  }

  getPerformanceForSelectedPortfolios() {
    this.isLoading = true;
    let selectedPortfolios = this.selectedPortfolios.filter((p) => p > 0);
    this.portfolioRepo
      .getPortfolioSummaryPerformance(
        this.selectedCurrency,
        selectedPortfolios,
        null,
        null
      )
      .then((val) => {
        this.isLoading = true;
        this.performances = val.data;

        this.localYTDPerformance = _.first(
          _.filter(this.performances, (performance) => {
            return performance.portfolioType.name === "Mauritius";
          })
        ).yearToDatePercentageMonthly;

        this.localYTDPerformance = this.convertToPercentage(
          this.localYTDPerformance
        );

        this.internationalYTDPerformance = _.first(
          _.filter(this.performances, (performance) => {
            return performance.portfolioType.name === "International";
          })
        ).yearToDatePercentageMonthly;

        this.internationalYTDPerformance = this.convertToPercentage(
          this.internationalYTDPerformance
        );

        this.combinedYTDPerformance = _.first(
          _.filter(this.performances, (performance) => {
            return performance.portfolioType.name === "Total";
          })
        ).yearToDatePercentageMonthly;

        this.combinedYTDPerformance = this.convertToPercentage(
          this.combinedYTDPerformance
        );
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  convertToPercentage = (val: number): string => {
    return (val * 100).toFixed(2);
  };

  updateData() {
    this.getAssetClassesBreakdown();
    this.getPerformanceForSelectedPortfolios();
  }

  getPortfolioManagerClientSummary() {
    this.isLoading = true;
    this.portfolioRepo
      .getPortfolioManagerClientSummary(this.selectedCurrency)
      .then((res) => {
        this.isLoading = true;
        this.clientSummaryItems = res.data as Array<any>;
        this.clientSummaryItems = _.orderBy(
          this.clientSummaryItems,
          "clientNumber"
        );

        this.clientSummaryItems.forEach((client) => {
          client.displayClientSummary = false;
          client.portfolioSummary.forEach((portfolioSummary) => {
            portfolioSummary.displayCash = false;
          });
        });

        this.isLoading = false;
      })
      .catch((err) => {
        this.isLoading = false;
      });
  }

  riskProfileDelta = (
    totalAssetValue: number,
    nav: number,
    high: number = 0,
    low: number = 0
  ) => {
    let assetPercentage = +((totalAssetValue / nav) * 100).toFixed(2);
    if (assetPercentage >= low && assetPercentage <= high) {
      return 0;
    } else if (assetPercentage >= low && assetPercentage >= high) {
      return +(assetPercentage - high).toFixed(2);
    } else {
      return +(assetPercentage - low).toFixed(2);
    }
  };

  displayPortfolioCashBalances = (portfolioSummary, clientId) => {
    portfolioSummary.displayCash = !portfolioSummary.displayCash;

    this.portfolioRepo
      .getPortfolioCashItemsForAdmin(
        clientId,
        portfolioSummary.portfolioId,
        this.selectedCurrency
      )
      .then((res) => {
        portfolioSummary.cashItems = res.data;
      })
      .catch((err) => {
        this.notifyjs("Failed to load cash balances " + extractErrorMessage(err));
      });
  };

  generateClientSecurityBalancesExcel = () => {
    this.isLoadingExcel = true;
    this.portfolioRepo
      .generatePortfolioManagerClientSecurityBalancesExcel()
      .then((res) => {
        var securityBalancesExcel = res.data as any;
        this.$window.open(securityBalancesExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs("Failed to generate excel.");
      })
      .finally(() => {
        this.isLoadingExcel = false;
      });
  };

  scrollToTopOfTable = () => {
    let table = document.querySelector("#portfolio-manager-summary-table");
    let tbody = table.querySelectorAll("tbody");
    tbody[0].scrollTop = 0;
  };

  getAccountRegionStyle = (account) => {
    return account.reportingCurrency == "MUR"
      ? "{'color' : 'red !important;'}"
      : "{'color' : 'blue !important;'}";
  };

  getAssetClassBalancesByExternalSource = () => {
    this.getSecurityBreakdownForGraphs();
    this.isLoadingAssetClassBreakDowns = true;
    this.portfolioRepo
      .getAssetClassBreakDownByExternalSourceLocality(
        this.selectedCurrency,
        this.selectedExternalSource,
        this.selectedLocality,
        null,
        this.displayAllClients
      )
      .then((res) => {
        this.assetClassTotals = res.data as Array<any>;

        this.assetClassesTotal = this.assetClassTotals.reduce((prev, next) => {
          return prev + next.total;
        }, 0);

        let pieChartData = this.assetClassTotals.map((assetClass) => {
          return {
            name: assetClass.name,
            value: this.getAssetClassPercentage(assetClass.total),
            itemStyle: {
              normal: {
                color: this.getItemColour(assetClass.name),
                fontFamily: "Helvetica",
              },
            },
          };
        });

        this.assetClassPieChartOptions = {
          title: {
            text: "Asset Classes",
            textStyle: {
              fontFamily: "Seravek",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {d}%",
          },
          grid: {
            containLabel: true,
          },
          toolbox: {
            feature: {
              saveAsImage: {
                title: "Save as Image",
              },
            },
          },
          series: {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: true,
            labelLine: {
              normal: {
                show: window.screen.width > this.minScreenWidth,
              },
            },
            label: {
              normal: {
                show: window.screen.width > this.minScreenWidth,
                fontSize: window.screen.width > 1920 ? 24 : 12,
              },
            },
            data: pieChartData,
          },
        };

        this.assetClassPieChartOptions.series.data =
          this.assetClassPieChartOptions.series.data.filter(
            (item) => item.value > 0
          );
        this.assetClassPieChart.setOption(this.assetClassPieChartOptions);
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to load Asset Class break down for the selected configuration " +
            extractErrorMessage(err)
        );
      })
      .finally(() => {
        this.isLoadingAssetClassBreakDowns = false;
        if (this.selectedAssetClassName) {
          this.loadSelectedAssetClassSecurities();
        }
      });
  };

  getAssetClassPercentage = (total) => {
    return ((total * 100) / this.assetClassesTotal).toFixed(2);
  };

  getItemColour(assetClass: string) {
    return AssetClassColourArray[AssetClassNameArray.indexOf(assetClass)];
  }

  private onAssetChartClick(params) {
    this.assetClassTableSwitch(params.data.name);
    this.$scope.$apply();
  }

  private assetClassTableSwitch = (assetClassName) => {
    this.selectedAssetClassName = assetClassName;
    this.getAggregatedSecurityBalancesByAssetClass();
  };

  loadSelectedAssetClassSecurities = () => {
    if (this.selectedAssetClassName) {
      this.getAggregatedSecurityBalancesByAssetClass();
    } else {
      this.loadTotalAssetClassSecurities();
    }
  };

  loadTotalAssetClassSecurities = () => {
    this.selectedAssetClassName = null;
    this.getAggregatedSecurityBalancesByAssetClass();
  };

  getAggregatedSecurityBalancesByAssetClass = () => {
    this.isLoadingAssetClassBreakDowns = true;
    this.portfolioRepo
      .getSecurityBreakDownByExternalSourceLocality(
        this.selectedCurrency,
        this.selectedExternalSource,
        this.selectedLocality,
        this.selectedAssetClassName,
        null,
        this.displayAllClients
      )
      .then((res) => {
        this.securityBalances = res.data as Array<any>;

        this.securityBalances = this.securityBalances.map((balance) => {
          return {
            assetClassId: balance.assetClassId,
            assetClassName: balance.assetClassName,
            costPrice: balance.costPrice,
            currency: balance.currency,
            description: balance.description,
            displayCurrency: balance.displayCurrency,
            geographyId: balance.geographyId,
            geographyName: balance.geographyName,
            id: balance.id,
            isin: balance.isin,
            modelPercentage: balance.modelPercentage,
            name: balance.name,
            price: balance.price,
            quantity: balance.quantity,
            sectorId: balance.sectorId,
            sectorName: balance.sectorName,
            totalMarketValue: balance.totalMarketValue,
            assetClassPercentage: (
              (balance.totalMarketValue * 100) /
              this.getSelectedAssetClassTotal()
            ).toFixed(2),
            totalPercentage: this.getAssetClassPercentage(
              balance.totalMarketValue
            ),
          };
        });
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to load Security balances for the selected asset class " +
            extractErrorMessage(err)
        );
      })
      .finally(() => {
        this.isLoadingAssetClassBreakDowns = false;
        var elmnt = document.getElementById("security-balances-card");
        elmnt.scrollIntoView();
      });
  };

  getSelectedAssetClassTotal = () => {
    if (this.selectedAssetClassName) {
      return this.assetClassTotals.find((asset) => {
        return asset.name == this.selectedAssetClassName;
      }).total;
    } else {
      return this.assetClassesTotal;
    }
  };

  getDefaultChartOptions = (titleName, chartData) => {
    let that = this;
    let pieChartOptions = {
      title: {
        text: titleName,
        textStyle: {
          fontFamily: "Seravek",
        },
      },

      tooltip: {
        trigger: "item",
        // "{b} : {d}%"
        formatter: (params) => {
          return ` ${params.data.name} -  ${params.data.value.toLocaleString(
            "en-EN",
            { style: "currency", currency: that.selectedCurrency }
          )}
            - ${that.getAssetClassPercentage(params.data.value)} %`;
        },
      },
      grid: {
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
        },
      },

      series: {
        type: "pie",
        radius: ["50%", "70%"],
        center: ["50%", "60%"],
        avoidLabelOverlap: true,
        labelLine: {
          normal: {
            show: window.screen.width > this.minScreenWidth,
          },
        },
        label: {
          normal: {
            show: window.screen.width > this.minScreenWidth,
            fontSize: window.screen.width > 1920 ? 24 : 12,
          },
        },
        data: chartData,
      },
    };

    return pieChartOptions;
  };

  getSecurityBreakdownForGraphs = () => {
    this.isLoadingAssetClassBreakDowns = true;
    this.portfolioRepo
      .getSecurityBreakDownByExternalSourceLocality(
        this.selectedCurrency,
        this.selectedExternalSource,
        this.selectedLocality,
        "",
        null,
        this.displayAllClients
      )
      .then((res) => {
        this.securityBalancesBreakdown = res.data as Array<any>;
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to load Security balances for the selected asset class " +
            extractErrorMessage(err)
        );
      })
      .finally(() => {
        this.isLoadingAssetClassBreakDowns = false;
        this.setGeographyBreakdownChart();
        this.setSectorBreakdownChart();
        this.setCurrencyBreakdownChart();
      });
  };

  setGeographyBreakdownChart = () => {
    let that = this;
    let count = -1;
    let geographyBalances = _.chain(this.securityBalancesBreakdown)
      .groupBy("geographyName")
      .map((balances, groupByName) => {
        count += 1;
        return {
          name: groupByName == "null" ? "Unknown" : groupByName,
          value: balances.reduce((prev, next) => {
            return prev + next.totalMarketValue;
          }, 0),
          itemStyle: {
            normal: {
              color: GraphColourArray[count],
              fontFamily: "Helvetica",
            },
          },
        };
      })
      .value();

    this.geographyPieChartOptions = this.getDefaultChartOptions(
      "Geographies",
      geographyBalances
    );
    if (this.geographyPieChart) {
      this.geographyPieChartOptions.series.data =
        this.geographyPieChartOptions.series.data.filter(
          (item) => item.value > 0
        );
      this.geographyPieChart.setOption(this.geographyPieChartOptions);
    } else {
      console.log("geography chart not loaded", this.geographyPieChart);
    }
  };

  setSectorBreakdownChart = () => {
    let that = this;
    let count = -1;
    let sectorBalances = _.chain(this.securityBalancesBreakdown)
      .groupBy("sectorName")
      .map((balances, groupByName) => {
        count += 1;
        return {
          name: groupByName == "null" ? "Unknown" : groupByName,
          value: balances.reduce((prev, next) => {
            return prev + next.totalMarketValue;
          }, 0),
          itemStyle: {
            normal: {
              color: GraphColourArray[count],
              fontFamily: "Helvetica",
            },
          },
        };
      })
      .value();

    this.sectorPieChartOptions = this.getDefaultChartOptions(
      "Sectors",
      sectorBalances
    );
    if (this.sectorPieChart) {
      this.sectorPieChartOptions.series.data =
        this.sectorPieChartOptions.series.data.filter((item) => item.value > 0);
      this.sectorPieChart.setOption(this.sectorPieChartOptions);
    } else {
      console.log("sector chart not loaded", this.sectorPieChart);
    }
  };

  setCurrencyBreakdownChart = () => {
    let that = this;
    let count = -1;
    let currencyBalances = _.chain(this.securityBalancesBreakdown)
      .groupBy("currency")
      .map((balances, groupByName) => {
        count += 1;
        return {
          name: groupByName == "null" ? "Unknown" : groupByName,
          value: balances.reduce((prev, next) => {
            return prev + next.totalMarketValue;
          }, 0),
          itemStyle: {
            normal: {
              color: GraphColourArray[count],
              fontFamily: "Helvetica",
            },
          },
        };
      })
      .value();

    this.currencyPieChartOptions = this.getDefaultChartOptions(
      "Currencies",
      currencyBalances
    );

    if (this.currencyPieChart) {
      this.currencyPieChartOptions.series.data =
        this.currencyPieChartOptions.series.data.filter(
          (item) => item.value > 0
        );
      this.currencyPieChart.setOption(this.currencyPieChartOptions);
    } else {
      console.log("currency chart not loaded", this.currencyPieChart);
    }
  };

  getClientSecurityBalancesForDate = () => {
    this.isLoadingExcel = true;
    let date = moment(this.selectedExcelDate).format("YYYY-MM-DD");
    this.portfolioRepo
      .generatePortfolioManagerClientSecurityBalancesExcel(date)
      .then((res) => {
        var securityBalancesExcel = res.data as any;
        this.$window.open(securityBalancesExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs("Failed to generate excel.");
      })
      .finally(() => {
        this.displayExcelDate = false;
        this.isLoadingExcel = false;
      });
  };

  redirectToFileProviders() {
    this.$state.go("root.fileproviders");
  }
}

export const portfolioManagerSummary: angular.IComponentOptions = {
  template: require("./portfolioManagerSummary.html"),
  controller: PortfolioManagerSummaryController,
};



// WEBPACK FOOTER //
// ./src/app/portfoliomanagement/portfolioManagerSummary.ts